import humps from 'humps'
import api from '@/api'

export default {
  fetch (filters, page) {
    return api.get(`/customers`, { params: humps.decamelizeKeys({ ...filters, page }) })
  },

  searchCustomers (data) {
    return api.post(`/customers/search`, data)
  },

  fetchById (id) {
    return api.get(`/customers/${id}`)
  },

  fetchUser (id) {
    return api.get(`/users/${id}`)
  },

  fetchProfile (id) {
    return api.get(`/users/${id}/profile`)
  },

  fetchAccounts (id) {
    return api.get(`/users/${id}/accounts`)
  },

  fetchPortfolios (id) {
    return api.get(`/users/${id}/portfolios`)
  },

  fetchComposition (id, type, limit) {
    return api.get(`/users/${id}/portfolios/composition`, { params: { type, limit } })
  },

  fetchStats () {
    return api.get('/advisory_stats')
  },

  fetchInvited (filters, page, userId = 'me') {
    return api.get(`/users/${userId}/invitations`, { params: humps.decamelizeKeys({ ...filters, page }) })
  },

  // Missions
  // ---------------------------------------------------------------------------
  fetchCustomerMissions (customerId) {
    return api.get(`/customers/${customerId}/missions`)
  },

  // Events
  // ---------------------------------------------------------------------------
  addInteraction (customerId, data) {
    return api.post(`/customers/${customerId}/events`, { event: data })
  },

  fetchInteractions (customerId, query) {
    return api.get(`/customers/${customerId}/events`, { params: humps.decamelizeKeys(query) })
  }
}
